function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 21h4V9H2zM4 2a2 2 0 102 2 2 2 0 00-2-2zm12 6a6 6 0 00-6 6v7h4v-7a2 2 0 014 0v7h4v-7a6 6 0 00-6-6z",
  fill: "#fff"
});

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggZD0iTTIgMjFoNFY5SDJ6TTQgMmEyIDIgMCAxMDIgMiAyIDIgMCAwMC0yLTJ6bTEyIDZhNiA2IDAgMDAtNiA2djdoNHYtN2EyIDIgMCAwMTQgMHY3aDR2LTdhNiA2IDAgMDAtNi02eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
export { SvgLinkedin as ReactComponent };